<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_95_444)">
		<path d="M3.125 10L16.875 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M11.25 4.375L16.875 10L11.25 15.625" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	</g>
	<defs>
		<clipPath id="clip0_95_444">
			<rect width="20" height="20" fill="white" transform="translate(20) rotate(90)"/>
		</clipPath>
	</defs>
</svg>
